import {createApp} from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue';
import router from './router'
import axios from 'axios'
import i18n from './i18n';
import './main.css';
import * as Icons from '@ant-design/icons-vue';


// import 'ant-design-vue/dist/antd.css';

axios.defaults.baseURL = 'http://61.59.16.136'
// axios.defaults.withCredentials = true;


const app = createApp(App);

// 全域註冊所有圖標
Object.keys(Icons).forEach((key) => {
    app.component(key, Icons[key]);
});

app.config.globalProperties.$axios = axios;
app.use(Antd);
app.use(router)
app.use(i18n);
app.mount('#app');
